import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-user-psw-reset-form',
  templateUrl: './user-psw-reset-form.component.html',
  styleUrls: ['./user-psw-reset-form.component.css']
})
export class UserPswResetFormComponent implements OnInit {
  form: FormGroup;
  tempPassword = '';
  invalidSubmit: boolean;

  @Output() pswResetted: EventEmitter<string> = new EventEmitter();

  constructor(private fb: FormBuilder) {
    this.tempPassword = this.generateRandomPassword();
    this.form = this.fb.group({
      'password': new FormControl(this.tempPassword)
    });
  }

  ngOnInit() {

  }

  generateRandomPassword() {
    let length = 10,
      charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!?$&',
      pwd = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      pwd += charset.charAt(Math.floor(Math.random() * n));
    }
    return pwd;
  }

  resetPsw() {
    this.pswResetted.emit(encodeURI(this.form.controls.password.value));
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-psw-reset-form/user-psw-reset-form.component.ts